import script from "./PreLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreLoader.vue?vue&type=script&setup=true&lang=ts"

import "./PreLoader.vue?vue&type=style&index=0&id=9d4d8d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d4d8d9a"]])

export default __exports__